module.exports = __webpack_public_path__ + "8ff0508d29b4d1aca9c9da985f830ee0.svg";